import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { HorseScene } from 'scenes';

class ClinicHorseContainer extends AbstractContainer {

  getTasks(params) {

    let horse = params.horse;

    return [
      {
        key: 'horse',
        exec: (done, failure) => {
          API.get(`horses/${horse}`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <HorseScene horse={results.horse} />
  }
}

export default ClinicHorseContainer;
